import { Navigate } from 'react-router-dom';
import { useOrganisation } from '../contexts/OrganisationContext';

const ProtectedReviewerRoute = ({ children }) => {
  const { activeRoleId } = useOrganisation();

  if (activeRoleId !== 'inera-reviewer') {
    return <Navigate to="/start" replace />;
  }

  return children;
};

export default ProtectedReviewerRoute;
